<template>
    <div class="position-relative">
      <label style="margin-top:-15px" for="cash-call-form-claim-date" v-if="label !== ''">{{ label }}</label>
      <DatePicker
        v-model="modelValue"
        :format="DATE_FORMAT"
        value-type="format"
        :disabled="disabled"
        :input-attr="{
          id: 'cash-call-form-claim-date'
        }"
      />
    </div>
  </template>
  
  <script>
  import { defineComponent, computed } from '@vue/composition-api'
  import DatePicker from 'vue2-datepicker'
  
  import { DATE_FORMAT } from '@constants'
  
  export default defineComponent({
    name: 'CashCallFormClaimDate',
    components: {
      DatePicker
    },
    props: {
      value: String,
      // Read-only by default: on the BDX-exists path these are derived from the
      // claim. The manual path (LIQ-1006) passes :disabled="false" so a claim
      // with no BDX yet can have its dates typed in.
      disabled: {
        type: Boolean,
        default: true
      },
      // Pass label="" where the surrounding layout already names the field.
      label: {
        type: String,
        default: 'Date Claim Made'
      }
    },
    emits: ['input'],
    setup(props, { emit }) {
      const modelValue = computed({
        get: () => props.value,
        set: (newValue) => emit('input', newValue)
      })
  
      return {
        DATE_FORMAT,
  
        modelValue
      }
    }
  })
  </script>
  
  <style scoped>
  .mx-datepicker {
    width: 100%;
  }
  
  .mx-datepicker >>> .mx-input {
    border-radius: 4px;
    border-color: #e9ecef;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  }
  </style>
  